export const runtimeConfigShared = {
    lstatSync: () => { },
    isFileReadStream(f) {
        return false;
    },
};
